import React, { Fragment, useEffect, useState } from "react";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { teams } from "../../utils/constants";
import { getReportLastDay, getReportMonthTimestamps } from "./reportDateUtils";

function ConsolidatedReport(props) {
  const [consolidatedData, setConsolidatedData] = useState([]);
  const {month, year, newReports, selectedTeam} = props
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month-1))

  function getDaysInMonth(year, month) {
    return getReportLastDay(year, month);
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    return getReportMonthTimestamps(year, month);
  }

  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(year, month);

  const visibleTeams = selectedTeam && selectedTeam.length > 0
    ? teams.filter(t => selectedTeam.includes(t.value))
    : teams.slice(0, 12);

  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1);
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + (times * 86400)
  }
  const calculateTotal = (index) =>{
   let total = 0
   visibleTeams.map((fieldname) => {
   total +=  getRevenueForTeamAndDate(fieldname.value,getTimestamp(index))
  })
  return total
}
  
  const getRevenueForTeamAndDate = (teamName, date) => {
    const teamEntry = consolidatedData.find(
      (entry) => entry.team === teamName && entry.date === date
    );

    // If the entry exists, return the total revenue
    if (teamEntry) {
      return teamEntry.totalRevenue;
    }

    // If the entry doesn't exist, return 0 or handle accordingly based on your use case
    return 0;
  };

  const fetchReport = async () => {
    try {
      let res = await api({
        url: "/reports/consolidatedreports",
        method: "POST",
        responseType: "json",
        data: {
          startTimestamp,
          endTimestamp,
          newReport: newReports,
          team: selectedTeam || null,
        },
      });
      if (res.code === 200) {
        setConsolidatedData(res.data);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCurrentDay = ()=>{
    setCurrentDay(getDaysInMonth(year, month -1))
  }

  const getTeamTotal = (teamValue) => {
    let total = 0;
    consolidatedData.map((entry) => {
      if (entry.team === teamValue) {
        total += entry.totalRevenue
      }
    })
    return total;
  };

  const calculateAllTeamTotal = () => {
    let total = 0;
    consolidatedData.map((entry) => {
      total += parseFloat(entry.totalRevenue);
    })
    return total;
  };

  useEffect(()=>{
    fetchReport()
    handleCurrentDay()
  },[month, year, newReports, selectedTeam])
  return (
    <div className="report-image">
      
      <div className="overflow-x-auto responsive-table">
        <table className="table table-bordered report-table" id="consolidated-report">
          <thead>
            <tr><td className="p-0" colSpan={visibleTeams.length + 2}><h4>Consolidated Report-Local</h4></td></tr>
            <tr>
              <th>Date</th>
              {visibleTeams.map((fieldname) => (
                <th key={fieldname.value}>{fieldname.label}</th>
              ))}
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: currentDay }, (_, index1) => (
              <tr key={index1}>
                <td>{`${index1 + 1}-${month}-${year}`}</td>
                {visibleTeams.map((fieldname) => (
                  <td key={fieldname.value} title={parseFloat(getRevenueForTeamAndDate(fieldname.value, getTimestamp(index1))).toFixed(2)}>
                    {Math.round(getRevenueForTeamAndDate(fieldname.value, getTimestamp(index1)))}
                  </td>
                ))}
                <td title={parseFloat(calculateTotal(index1)).toFixed(2)}>{Math.round(calculateTotal(index1))}</td>
              </tr>
            ))}
            <tr>
              <td>Total</td>
              {visibleTeams.map((fieldname) => (
                <td key={fieldname.value} title={parseFloat(getTeamTotal(fieldname.value)).toFixed(2)}>{Math.round(getTeamTotal(fieldname.value))}</td>
              ))}
              <td title={parseFloat(calculateAllTeamTotal()).toFixed(2)}>{Math.round(calculateAllTeamTotal())}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ConsolidatedReport;
